import $ from "jquery";

export const resizeLeftMenu = () => {
    const leftMenu = $('.left-menu');
    const leftMenuWrapper = $('.left-menu-wrapper');
    const MAX_WIDTH_FOR_SMALL_PC = 1279;

    if (leftMenu.length === 0) {
        return;
    }

    const header = $('#header');

    leftMenu.css('height', '');
    leftMenuWrapper.css('height', '');

    const barHeight = document.documentElement.clientHeight - header.height() + 5;

    if (window.window.innerWidth > MAX_WIDTH_FOR_SMALL_PC) {
        leftMenu.css('height', barHeight);
        leftMenuWrapper.css('height', barHeight);
    }
}
